require('./vendor.ts');
angular.module('capability-ng-reports', ['ngSanitize', 'ngAria']);

import './core';

export const REPORTS = 'capability-ng-reports';
export * from './queries/reports_priority_feed_query';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/main.ts